import { Link } from "gatsby"
import React from "react"
import * as styles from "../assets/css/navigation.module.css"

const Footer = () => {
  return (
    <div>
      <div className={styles.indexMiddleText}>Mehr Erfahren</div>
      <div className={styles.indexNavigation}>
        <Link to="/wannzumneurologen">
          <div className={styles.indexNavigationBox}>
            <img
              src="/calendar.png"
              alt="Wann zum Neurologen?"
              className={styles.indexNavigationBoxIcon}
            />
            <div className={styles.indexNavigationBoxText}>
              Wann zum Neurologen?
            </div>
          </div>
        </Link>
        <Link to="/leistungen">
          <div className={styles.indexNavigationBox}>
            <img
              src="/offer.png"
              alt="Leistungen"
              className={styles.indexNavigationBoxIcon}
            />
            <div className={styles.indexNavigationBoxText}>Leistungen</div>
          </div>
        </Link>
        <div className={styles.indexNavigationHidden}>
          <Link to="/schwerpunkte">
            <div className={styles.indexNavigationBox}>
              <img
                src="/light-bulb.png"
                alt="Schwerpunkte"
                className={styles.indexNavigationBoxIcon}
              />
              <div className={styles.indexNavigationBoxText}>Schwerpunkte</div>
            </div>
          </Link>
          <Link to="/ganzheitlichdenken">
            <div className={styles.indexNavigationBox}>
              <img
                src="/brain.png"
                alt="Ganzheitlich Denken"
                className={styles.indexNavigationBoxIcon}
              />
              <div className={styles.indexNavigationBoxText}>
                Ganzheitlich Denken
              </div>
            </div>
          </Link>
        </div>
      </div>
      <div className={styles.indexNavigation2}>
        <Link to="/schwerpunkte">
          <div className={styles.indexNavigationBox}>
            <img
              src="/light-bulb.png"
              alt="Schwerpunkte"
              className={styles.indexNavigationBoxIcon}
            />
            <div className={styles.indexNavigationBoxText}>Schwerpunkte</div>
          </div>
        </Link>
        <Link to="/ganzheitlichdenken">
          <div className={styles.indexNavigationBox}>
            <img
              src="/brain.png"
              alt="Ganzheitlich Denken"
              className={styles.indexNavigationBoxIcon}
            />
            <div className={styles.indexNavigationBoxText}>
              Ganzheitlich Denken
            </div>
          </div>
        </Link>
      </div>
    </div>
  )
}

export default Footer
